import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Sizes from '../Assets/Sizes';
import { FormattedMessage } from "react-intl";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const MultiSelect = styled.div`
  width: 100%;
  position: relative;
  display: flex;

  .fade-enter {
    opacity: 0;
    transform: translateX(15px);
  }

  .fade-enter-active {
    opacity: 1;
    transform: translateX(0);

    transition: all 300ms;
  }

`;

const Option = styled.button`
  &:not(:first-of-type):not(:last-of-type) {
    margin-left: ${ Sizes.defaultPadding };
    margin-right: ${ Sizes.defaultPadding };
  }

  // When there are only 2 items.
  &:nth-last-of-type(2):nth-of-type(1) {
    margin-left: ${ Sizes.defaultPadding };
  }

  padding: ${ Sizes.defaultPadding };


  flex-grow: 1;
  flex-basis: 0;


  --mdc-theme-text-primary-on-background: ${ p => p.theme.colors.safeText };
  box-shadow: ${ p => p.theme.colors.defaultBoxShadow };
  border: none;
  border-radius: ${ Sizes.listItemBorderRadius };
  background-color: ${ p => p.theme.colors.surfaceFront };
  margin-top: ${ Sizes.defaultPadding };
  // text-align: right;
  // text-align: start;
  color: ${ p => p.theme.colors.safeText };
  font-size: 1.1rem;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */

  .round {
    position: relative;

    span {
      font-size: 0.9em;
    }
  }


  .round label {
    background-color: transparent;
    border: 2px solid ${ p => p.theme.colors.safeText };
    border-radius: 50%;
    cursor: pointer;
    height: 20px;
    right: ${ p => p.ltr ? 'auto' : '0' };
    left: ${ p => p.ltr ? '-10px' : 'auto' };

    position: absolute;
    top: 0;
    width: 20px;

    > div {

      margin-right: ${ p => p.ltr ? '0' : '25px' };
      margin-left: ${ p => p.ltr ? '25px' : '0' };
      margin-top: -3px;
    }
  }

  .round label:after {
    border: 2px solid ${ p => p.theme.colors.safeText };
    border-top: none;
    border-right: none;
    content: "";
    opacity: 0;
    position: absolute;
    transform: rotate(-45deg);
    width: 12px;

    height: 5px;
    left: 3px;
    top: 5px;
  }

  .round input[type="checkbox"] {
    visibility: hidden;
  }

  .round input[type="checkbox"]:checked + label {
    background-color: ${ p => p.theme.colors.primaryColor };
    border-color: ${ p => p.theme.colors.primaryColor };
  }

  .round input[type="checkbox"]:checked + label:after {
    opacity: 1;
  }
`;

export default class MultiSelectComponent extends PureComponent {
	state = { items: [] };

	componentDidMount() {
		if (this.props.options) {
			this.setState({ items: this.props.options });
		}
	}


	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.options) {
			this.setState({ items: nextProps.options });
		}
	}

	render() {

		const { props } = this;
		const clicked = (ev, option) => {
			ev.stopPropagation();
			ev.preventDefault();
			props.toggleOption(option);
		};

		const items = this.state.items.map((option, idx) => {
			const delay = Math.max(0, idx * 150);

			return (
				<CSSTransition
					timeout={ 300 + delay }
					classNames="fade"
					key={ option.value }>
					<Option count={ this.state.items } style={ { 'transitionDelay': `${ delay }ms` } }
							onClick={ (ev) => clicked(ev, option) } ltr={ props.ltr }>
						<div className="round">
							<input type="checkbox" id={ option.value } checked={ option.checked }
								   onChange={ () => props.toggleOption(option) }/>
							<label htmlFor={ option.value }>
								<div><FormattedMessage id={ option.label }/></div>
							</label>
						</div>

						{/*</Checkbox>*/ }
					</Option>
				</CSSTransition>
			);
		});

		return <MultiSelect>
			<TransitionGroup component={ null }>
				{ items }
			</TransitionGroup>
		</MultiSelect>
	}
}
